export const enum SubscribeConsentDataHooks {
  checkbox = 'subscribe-consent-checkbox',
  checkboxLabelText = 'subscribe-consent-label-text',
  container = 'subscribe-consent-container',
  link = 'subscribe-consent-link',
}
